export const ACA = {
  score: 7,
  loading: 5,
  counter: 5,
  interval: 1000,
  timeout: 5000,
  enable: false,
  enableDcp: false
}
